const PROGRESSIVE_IMAGE_CLASS = 'blog-progressive-img'
const PROGRESSIVE_IMAGE_BOUND = 'blogProgressiveBound'

type ImageListenerPair = {
  load: () => void
  error: () => void
}

function markImageLoaded(img: HTMLImageElement) {
  img.classList.add('is-loaded')
}

function setupImageBase(img: HTMLImageElement) {
  img.classList.add(PROGRESSIVE_IMAGE_CLASS)
  img.classList.add('is-progressive')
  if (!img.getAttribute('loading')) {
    img.setAttribute('loading', 'lazy')
  }
  if (!img.getAttribute('decoding')) {
    img.setAttribute('decoding', 'async')
  }
}

export function bindProgressiveImages(container: ParentNode | null | undefined) {
  if (!import.meta.client || !container) {
    return () => {}
  }

  const listeners = new Map<HTMLImageElement, ImageListenerPair>()
  const images = Array.from(container.querySelectorAll('img')) as HTMLImageElement[]

  for (const img of images) {
    setupImageBase(img)
    if (img.complete && img.naturalWidth > 0) {
      markImageLoaded(img)
      continue
    }
    if (img.dataset[PROGRESSIVE_IMAGE_BOUND] === '1') {
      continue
    }
    const onLoad = () => {
      markImageLoaded(img)
    }
    const onError = () => {
      img.classList.add('is-error')
      markImageLoaded(img)
    }
    img.addEventListener('load', onLoad, { passive: true })
    img.addEventListener('error', onError, { passive: true })
    img.dataset[PROGRESSIVE_IMAGE_BOUND] = '1'
    listeners.set(img, { load: onLoad, error: onError })
  }

  return () => {
    for (const [img, pair] of listeners) {
      img.removeEventListener('load', pair.load)
      img.removeEventListener('error', pair.error)
      delete img.dataset[PROGRESSIVE_IMAGE_BOUND]
    }
    listeners.clear()
  }
}
